
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 255 414","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"nonzero","fill":"none"}},[_c('path',{attrs:{"fill":"#343434","d":"M126.962.282l-2.762 9.39V282.11l2.762 2.757 126.463-74.752z"}}),_c('path',{attrs:{"fill":"#8C8C8C","d":"M126.963.282L.5 210.115l126.463 74.753V152.634z"}}),_c('path',{attrs:{"fill":"#3C3C3B","d":"M126.962 308.812l-1.557 1.897v97.049l1.557 4.547L253.5 234.097z"}}),_c('path',{attrs:{"fill":"#8C8C8C","d":"M126.963 412.303V308.81L.5 234.096z"}}),_c('path',{attrs:{"fill":"#141414","d":"M126.962 284.867l126.46-74.751-126.46-57.481z"}}),_c('path',{attrs:{"fill":"#393939","d":"M.5 210.116l126.462 74.75v-132.23z"}})])])
          )
        }
      }
    